// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1jxKY","top":"style_top__1jmLE","title":"style_title__3Ma_k","text":"style_text__29G5_"};